import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { ClinicalTrials } from "@/types/clinicalTrials.types";
import { ClinicalTrialStatus } from "@/types/clinicalTrialStatus.types";
import { CompanyWebsiteVariousPage } from "@/types/companyWebsiteVariousPage";
import { ConferenceSchedule } from "@/types/conferenceSchedule.types";
import { CTG } from "@/types/ctg.types";
import { DealFiling, Deals } from "@/types/deals.types";
import { ExpeditedProgram } from "@/types/expeditedProgram.types";
import { Publication } from "@/types/publication.types";
import { PublicationJournal } from "@/types/publicationJournal.types";
import { Regulatory } from "@/types/regulatory.types";
import { VentureCapital, FundingFiling } from "@/types/ventureCapital.types";
import { useUpdateEntryDataMutate } from "@api/entryData/entryData";
import { EXPEDITED_PROGRAM } from "@FillInTableContainer/shared/constants/expeditedProgramKey.constants";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { useSectionCodeToClassification } from "./useSectionCode";

export const useUpdateEntryData = () => {
  const { mutateAsync: updateEntryDataMutate } = useUpdateEntryDataMutate(
    getPressIdFromURL(),
  );

  const sectionCode = useSectionCodeToClassification();

  const updateEntryData = async (
    entryData: Partial<{
      "Clinical Trials": Partial<ClinicalTrials>;
      "Clinical Trial Status": Partial<ClinicalTrialStatus>;
      [ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages]: Partial<CompanyWebsiteVariousPage>;
      Regulatory: Partial<Regulatory>;
      Deals: Partial<Deals>;
      [EXPEDITED_PROGRAM]: Partial<ExpeditedProgram>;
      [ENTRY_DATA_SECTION_KEYS.ventureCapital]: Partial<VentureCapital>;
      [ENTRY_DATA_SECTION_KEYS.publication]: Partial<Publication>;
      [ENTRY_DATA_SECTION_KEYS.publicationJournal]: Partial<PublicationJournal>;
      [ENTRY_DATA_SECTION_KEYS.conferenceSchedule]: Partial<ConferenceSchedule>;
      [ENTRY_DATA_SECTION_KEYS.dealFiling]: Partial<DealFiling>;
      [ENTRY_DATA_SECTION_KEYS.fundingFiling]: Partial<FundingFiling>;
      [ENTRY_DATA_SECTION_KEYS.ctg]: Partial<CTG>;
    }>,
    isDbSaved?: boolean,
  ) => {
    await updateEntryDataMutate({
      entryData,
      isDbSaved: isDbSaved || false,
      sectionCode,
    });
  };

  return updateEntryData;
};
